
document.addEventListener('status:shopify:login', (event) => {
  if (event.returnValue == true) {
    const loggedOutEl = document.querySelectorAll('[data-status-app-hide-logged-in]')
    const welcomeText = window.theme.strings.welcomeText

    // Hide login buttons
    loggedOutEl.forEach(el => {
      el.style.display = 'none'
    })

    // Show user name when logged in and append it before title
    const userElementHTML = `
      <div class="sec-QuizContent_User" data-status-app-user-logged-in>
        <p>${welcomeText} ${window.StatusAccounts.customer.firstName ? window.StatusAccounts.customer.firstName : ''}</p>
      </div>
    `

    const userElement = document.createElement('div')
    userElement.innerHTML = userElementHTML.trim()

    const titleElement = document.querySelector('.sec-QuizContent_Title')
    titleElement.parentNode.insertBefore(userElement, titleElement)
  }
})
